import validateVar from "./validation/validateVariable";

export default function getHandlingFee(consultant_charge_amount, eless_margin) {
    if (!validateVar(consultant_charge_amount)) {
        consultant_charge_amount = 0;
    }
    return +consultant_charge_amount + +eless_margin;
}
